/* global  */ // tUrl等のグローバル変数を宣言する
import scrollLock from './functions/_scrollLock.js' // スクロールロック

import './module/_hashScroll' // アンカーリンクスクロール
import './module/_spMenuToggle' // SPメニュー開閉
import './module/_toast' // トースト通知

import './_api'
import './_ajax'
import './_rating'
import './_textCount'

import './_top'
import './_ppv'
import './_review'
import './_videoList'
import './_video'
import './_cart'
// import './_videoHover'
import './_form'
import './_subscription'

import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言

// import 'core-js/features/number/is-nan' // SwiperのIE対応
// import 'custom-event-polyfill' // SwiperのIE対応
// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

/*
 ##     ## ##     ##          ######  ##    ## ##    ##  ######
 ##     ## ##     ##         ##         ####   ####  ## ##
 ######### ##     ## #######  ######     ##    ## ## ## ##
 ##     ##  ##   ##                ##    ##    ##  #### ##
 ##     ##    ###             ######     ##    ##    ##  ######
ホバー中、その要素とその連動要素全てに.hoverを付与

<a href="" class="js-hoverSync js-hoverSync--hoge" data-hover-sync="hoge"></a>
<a href="" class="js-hoverSync js-hoverSync--hoge" data-hover-sync="hoge"></a>
*/
const hoverSyncClass = 'js-hoverSync'
if (document.getElementsByClassName(hoverSyncClass)[0]) {
  hoverSync()
}
function hoverSync() {
  const hoverActiveClass = 'hover'
  const hoverItems = document.getElementsByClassName(hoverSyncClass)
  for (let index = 0; index < hoverItems.length; index++) {
    const hoverItem = hoverItems[index]
    const hoverTargets = document.getElementsByClassName(hoverSyncClass + '--' + hoverItem.dataset.hoverSync)
    hoverItem.addEventListener(
      'mouseover',
      function () {
        for (let index = 0; index < hoverTargets.length; index++) {
          hoverTargets[index].classList.add(hoverActiveClass)
        }
      },
      false
    )
    hoverItem.addEventListener(
      'mouseout',
      function () {
        for (let index = 0; index < hoverTargets.length; index++) {
          hoverTargets[index].classList.remove(hoverActiveClass)
        }
      },
      false
    )
  }
}

//   ####  #####  ##                    ##  ##   ##  ###    ###  #####
//  ##     ##     ##                    ##  ##   ##  ## #  # ##  ##  ##
//   ###   #####  ##      ########      ##  ##   ##  ##  ##  ##  #####
//     ##  ##     ##                ##  ##  ##   ##  ##      ##  ##
//  ####   #####  ######             ####    #####   ##      ##  ##
// セレクトボックスで選んだURLにジャンプする
const selectJump = document.getElementsByClassName('js-selectJump')
if (selectJump[0]) {
  window.addEventListener('change', function (e) {
    if (!e.target.classList.contains('js-selectJump')) {
      return
    }
    window.location.href = e.target.value
  })
}

//  ###    ###   #####   ####      ###    ##
//  ## #  # ##  ##   ##  ##  ##   ## ##   ##
//  ##  ##  ##  ##   ##  ##  ##  ##   ##  ##
//  ##      ##  ##   ##  ##  ##  #######  ##
//  ##      ##   #####   ####    ##   ##  ######

const modalOverlay = document.getElementById('modalOverlay') // モーダル用オーバーレイ
const modals = document.getElementsByClassName('js-modal') // モーダル本体
if (modals[0]) {
  document.body.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-open')) {
      return
    }
    e.preventDefault()
    window.modalClose()
    const target = e.target.closest('.js-modal-open').dataset.modal

    const openModals = document.querySelectorAll('.js-modal--' + target)
    for (const openModal of openModals) {
      openModal.classList.add('active')
    }

    modalOverlay.classList.add('active')
    scrollLock('body', '.js-modal')

    // iOSバージョンが古い場合、modalが表示された後にSwiperを初期化
    if (isOldIOS()) {
      initImageSlideSwiper()
      setTimeout(() => {}, 200)
    }
  })
  // モーダル撤去
  document.body.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-close')) {
      return
    }
    // 処理中モーダルが表示されている場合は閉じない
    const processingModal = document.querySelector('.js-modal--processing.active')
    if (processingModal) {
      e.preventDefault()
      return
    }
    e.preventDefault()
    window.modalClose()
    modalOverlay.classList.remove('active')
    scrollLock('body', '.js-modal')
  })
}

window.modalClose = function () {
  // 処理中モーダルが表示されている場合は閉じない
  const processingModal = document.querySelector('.js-modal--processing.active')
  if (processingModal) {
    return
  }
  // モーダルを消す
  for (let index = 0; index < modals.length; index++) {
    const modal = modals[index]
    modal.classList.remove('active')
  }
  modalOverlay.classList.remove('active')
  scrollLock('body', '.js-modal')
}

// 購入確定ボタンの処理
document.body.addEventListener('click', (e) => {
  if (!e.target.closest('.js-purchase-submit')) {
    return
  }
  e.preventDefault()
  const button = e.target.closest('.js-purchase-submit')
  const form = button.closest('form')

  if (!form) {
    return
  }

  // 確認モーダルを閉じる
  window.modalClose()

  // 処理中モーダルを開く
  const processingModals = document.querySelectorAll('.js-modal--processing')
  for (const processingModal of processingModals) {
    processingModal.classList.add('active')
  }
  if (modalOverlay) {
    modalOverlay.classList.add('active')
    scrollLock('body', '.js-modal')
  }

  // 3.2秒待機してからフォームを送信
  setTimeout(() => {
    form.submit()
  }, 3200)
})

/*
  ######          ########  #######   ######    ######   ##       ########
 ##                  ##    ##     ## ##        ##        ##       ##
 ##       #######    ##    ##     ## ##   #### ##   #### ##       ######
 ##                  ##    ##     ## ##    ##  ##    ##  ##       ##
  ######             ##     #######   ######    ######   ######## ########

// クリックされたとき、属するグループのクラスを反転させる
<button type="button" class="js-clickToggle" data-toggle-group="hogeGroup"></button>
<div class="js-clickToggle--hogeGroup"></div>

*/

window.addEventListener('click', function (e) {
  if (!e.target.classList.contains('js-clickToggle')) {
    return
  }
  const group = e.target.dataset.toggleGroup
  toggleGroup(group, 'active')
})

function toggleGroup(group, className = 'active') {
  const hide = document.getElementsByClassName('js-clickToggle--' + group)
  for (let index = 0; index < hide.length; index++) {
    hide[index].classList.toggle(className)
  }
}

//   ####            ######   #####     ###     ####  ######
//  ##                 ##    ##   ##   ## ##   ##       ##
//  ##     ########    ##    ##   ##  ##   ##   ###     ##
//  ##                 ##    ##   ##  #######     ##    ##
//   ####              ##     #####   ##   ##  ####     ##
/*
<button type="button" class="js-clickToggle js-clickToggle--fav-<?php echo $productID; ?> js-api js-clickToast ppvFav__btn md-btn greenLine activeToggle" data-param="" data-toggle-group="fav-<?php echo $productID; ?>" data-info="fav" data-id="<?php echo $productID; ?>" data-toast-on="お気に入りに登録しました" data-toast-off="お気に入りから削除しました">
</button>
*/
window.addEventListener('click', function (e) {
  if (!e.target.classList.contains('js-clickToast')) {
    return
  }
  // .activeの有無でONOFFを判断　.js-clickToggleの処理が先に行われる前提
  if (e.target.classList.contains('active')) {
    window.popToast(e.target.dataset.toastOn)
  } else {
    window.popToast(e.target.dataset.toastOff)
  }
})

//   ####   ####  #####     #####   ##      ##
//  ##     ##     ##  ##   ##   ##  ##      ##
//   ###   ##     #####    ##   ##  ##      ##
//     ##  ##     ##  ##   ##   ##  ##      ##
//  ####    ####  ##   ##   #####   ######  ######

/**
 * @function scrollValToggle
 * @description スクロール量を基準にクラスを着脱する
 * @param {String} targetSelector ターゲットとする一意なセレクタ
 * @param {Number} scrollValStart 有効範囲となるスクロール量　上からの距離
 * @param {Number|Boolean} [scrollValEnd=false] 有効範囲外となるスクロール量　下からの距離
 * @param {String} toggleClass 切り替えるクラス名
 * @return {Void}
 */
scrollValToggle('#pagetop', 500, false, 'active')
function scrollValToggle(targetSelector, scrollValStart = 500, scrollValEnd = false, toggleClass = 'active') {
  if (!document.querySelector(targetSelector)) {
    return
  }
  let isExecute = false // 実行中フラグ
  let scrollY = 0 // 縦方向のスクロール量
  const target = document.querySelector(targetSelector) // ターゲット要素
  let scToggleActive = false // ターゲット要素のONOFF状態
  document.addEventListener('scroll', function (ev) {
    scrollValToggleApply()
  })
  scrollValToggleApply() // 初回起動
  function scrollValToggleApply() {
    if (isExecute) {
      // 実行中ならスキップ
      return
    }
    isExecute = true
    // レンダリング準備が整ったら開始
    requestAnimationFrame(function () {
      scrollY = window.scrollY // スクロール量
      if (scrollY >= scrollValStart && !scToggleActive) {
        //トップから指定px以上スクロールしたらON
        target.classList.add(toggleClass)
        scToggleActive = true
      } else if (scrollY < scrollValStart && scToggleActive) {
        //スクロールが足りない時はOFF
        target.classList.remove(toggleClass)
        scToggleActive = false
      }
      if (scrollValEnd && scToggleActive) {
        // 終了ラインが設定されている場合は終了判定
        if (scrollY + window.innerHeight > document.documentElement.offsetHeight - scrollValEnd) {
          //スクロール終了範囲を過ぎていたらOFF
          target.classList.remove(toggleClass)
          scToggleActive = false
        }
      }
      isExecute = false
    })
  }
}

if ($('#review').length) {
  //  ##                    ##  ##   ##  ####     ####    #####
  //  ##                    ##  ##   ##  ##  ##  ##       ##
  //  ##      ########      ##  ##   ##  ##  ##  ##  ###  #####
  //  ##                ##  ##  ##   ##  ##  ##  ##   ##  ##
  //  ######             ####    #####   ####     ####    #####

  // 高評価、低評価のカウント
  /*
<button type="button" class="js-likeJudge js-likeJudge--<?php echo $reviewID; ?>-good" data-like-judge="<?php echo $reviewID; ?>" data-like-judge-type="good"></button>
<span class="js-likeJudge-count--<?php echo $reviewID; ?>-good">0</span>
<button type="button" class="js-likeJudge js-likeJudge--<?php echo $reviewID; ?>-bad" data-like-judge="<?php echo $reviewID; ?>" data-like-judge-type="bad"></button>
<span class="js-likeJudge-count--<?php echo $reviewID; ?>-bad">0</span>
  */
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-likeJudge')) {
      return
    }

    const item = e.target
    const id = item.dataset.likeJudge
    const type = item.dataset.likeJudgeType
    const reverse = type === 'good' ? 'bad' : 'good'
    const count = document.querySelector('.js-likeJudge-count--' + id + '-' + type)

    // console.log({ id })
    // console.log({ type })
    // console.log({ reverse })
    // console.log('.js-likeJudge-count--' + id + '-' + type)
    // console.log({ count })

    if (item.classList.contains('active')) {
      // 加算の取り消し
      count.innerText = parseInt(count.innerText, 10) - 1
    } else {
      // 加算
      count.innerText = parseInt(count.innerText, 10) + 1

      // 反対の評価の加算取り消し
      const reverseItem = document.querySelector('.js-likeJudge--' + id + '-' + reverse)

      if (reverseItem.classList.contains('active')) {
        // 加算の取り消し
        const reverseCount = document.querySelector('.js-likeJudge-count--' + id + '-' + reverse)
        reverseItem.classList.remove('active')
        reverseCount.innerText = parseInt(reverseCount.innerText, 10) - 1
      }
    }

    item.classList.toggle('active')
  })
}

$('.star5_rating').each(function (index, e) {
  //　レビューの値
  let starRate = $(this).data('rate')
  //　0.5で割り切れない場合
  if (starRate > 0) {
    //　widthの値
    let widthRate = Math.round((starRate / 5) * 100, 2)
    //　追加する疑似要素（星のレビュー値のdata-rate値、widthを設定する
    let css = '.star5_rating[data-rate="' + starRate + '"]:after{width:' + widthRate + '%;}'

    //　style要素を作成してCSSを設定
    let style = $('<style>')
    style.text(css)
    //　style要素を全体に追加
    $('body').append(style)
  } else {
    let css = '.star5_rating[data-rate="0"]:after{width:0%;}'
    let style = $('<style>')
    style.text(css)
    //　style要素を全体に追加
    $('body').append(style)
  }
})

if ($('#search').length) {
  $('.js-search-keyword-clear').click(function () {
    $('input[type="text"]').val('')
    $('input[type="radio"]').prop('checked', false)
    $('input[type="checkbox"]').prop('checked', false)
  })
  $('.js-search-tag').click(function () {
    $(this).toggleClass('active')
  })

  $('.js-search-tag-clear').click(function () {
    $('.js-search-tag').removeClass('active')
  })
}

if ($('#page-model').length) {
  $('select[name="sort"]').change(function () {
    // console.log($(this).val())
    if ($(this).val() === 'jp-order') {
      $('.js-model-tab').addClass('show')
    } else {
      $('.js-model-tab').removeClass('show')
    }
  })
}

//  ####    #####   ####  ######  #####     #####   ##    ##
//  ##  ##  ##     ##       ##    ##  ##   ##   ##   ##  ##
//  ##  ##  #####   ###     ##    #####    ##   ##    ####
//  ##  ##  ##        ##    ##    ##  ##   ##   ##     ##
//  ####    #####  ####     ##    ##   ##   #####      ##
/*
data属性に対応するクラスのDOMを削除する
<button type="button" class="js-destroy" data-destroy="hoge">
    削除
</button>
<div class="js-destroy--hoge">これが消える</div>
*/

window.addEventListener('click', function (e) {
  // 指定のクラスを持つ
  if (!e.target.classList.contains('js-destroy')) {
    return
  }
  const target = e.target.dataset.destroy
  const destroyList = document.getElementsByClassName('js-destroy--' + target)

  for (const iterator of destroyList) {
    iterator.parentNode.removeChild(iterator)
  }
  window.popClose()
})

// パスワードの表示、非表示
if (document.getElementsByClassName('js-togglePassword')[0]) {
  document.querySelectorAll('.js-togglePassword').forEach(function (toggle) {
    const wrapper = toggle.closest('.FormItem__password')
    const input = wrapper.querySelector('input[type="password"]')
    const iconShow = toggle.querySelector('.-show')
    const iconHide = toggle.querySelector('.-hide')

    if (input.type === 'password') {
      iconShow.style.display = 'inline'
      iconHide.style.display = 'none'
    } else {
      iconShow.style.display = 'none'
      iconHide.style.display = 'inline'
    }

    toggle.addEventListener('click', function () {
      const isHidden = input.type === 'password'
      input.type = isHidden ? 'text' : 'password'

      iconShow.style.display = isHidden ? 'none' : 'inline'
      iconHide.style.display = isHidden ? 'inline' : 'none'
    })
  })
}

function initImageSlideSwiper() {
  //  ##  ###    ###    ###     ####    #####
  //  ##  ## #  # ##   ## ##   ##       ##
  //  ##  ##  ##  ##  ##   ##  ##  ###  #####
  //  ##  ##      ##  #######  ##   ##  ##
  //  ##  ##      ##  ##   ##   ####    #####
  if (document.getElementById('imageSlide')) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const slideItem = document.getElementById('imageSlide')
    const sliderName = 'imageSlide'
    const nextBtn = document.querySelector('.swiper-button-next--' + sliderName)
    const prevBtn = document.querySelector('.swiper-button-prev--' + sliderName)

    const imageSlideSwiper = new Swiper(slideItem, {
      // init: false, // 自動で初期化しない（imageSlideSwiper.init()で初期化）
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 50, // アニメ速度
      loop: false, // ループ
      // autoHeight: true, // スライドごとに高さを変動させる
      fadeEffect: {
        // フェードオプション
        crossFade: true, // クロスフェード
      },
      navigation: {
        nextEl: nextBtn, // 前のページボタンを呼び出す要素
        prevEl: prevBtn, // 次のページボタンを呼び出す要素
      },
      preventClicks: false,
      preventClicksPropagation: false,
      simulateTouch: true,
      allowTouchMove: true,
    })

    // let lastSlide = null
    window.addEventListener('click', function (e) {
      // 指定のクラスを持つ
      if (e.target.closest('.js-slideShift')) {
        const slide = parseInt(e.target.dataset.slide, 10)

        imageSlideSwiper.slideTo(slide - 1)
      }
      if (e.target.closest('.swiper-slide')) {
        const next = imageSlideSwiper.slideNext()
        if (!next) {
          window.modalClose() // 最終スライドでモーダルを閉じる
        }
      }
    })
  }
  console.log('Swiper initialized (for old iOS)')
}

// iOSバージョンが古いかどうかをチェック
function isOldIOS() {
  const ua = navigator.userAgent

  // iOS
  const isIOS = /iP(hone|od|ad)/.test(ua)
  if (!isIOS) return false

  // バージョンを取得
  const match = ua.match(/OS (\d+)_?(\d+)?_?(\d+)?/)
  if (!match) return false

  const major = parseInt(match[1], 10)
  // const minor = parseInt(match[2] || '0', 10); // 詳細なバージョンを取得する場合は使用
  return major < 13 // iOSが13未満の場合はtrue
}
